var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], { autoescape: true });
} else {
	env = nunjucks.currentEnv;
}
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["../Config.njk"] = require( "../Config.njk" );




var shim = require("/codebuild/output/src2118274201/src/tv-monitor-ui/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["src/js/view/pages/Dashboard.njk"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
var tasks = [];
tasks.push(
function(callback) {
env.getTemplate("../Config.njk", false, "src/js/view/pages/Dashboard.njk", null, function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
callback(null,t_1);});
});
tasks.push(
function(template, callback){
template.render(context.getVariables(), frame, function(t_4,t_2) {
if(t_4) { cb(t_4); return; }
callback(null,t_2);});
});
tasks.push(
function(result, callback){
output += result;
callback(null);
});
env.waterfall(tasks, function(){
output += "\n\n<div class=\"main\">\n    <div class=\"region-header\"></div>\n    <div class=\"region-body\"></div>\n    <div class=\"region-footer\">\n        <div class=\"xola-banner\">\n            Powered by <img src=\"img/xola-logo.png\" />\n        </div>\n    </div>\n</div>\n<div class=\"region-settings hidden\"></div>";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["src/js/view/pages/Dashboard.njk"] , dependencies)


//////////////////
// WEBPACK FOOTER
// ./src/js/view/pages/Dashboard.njk
// module id = 189
// module chunks = 0